<template>
    <div class="font-body">
        <!-- Navigation -->
        <LandingNav
            background-color="#FFFFFF"
            logo-light="/hkcm/images/logo-on-light-background.svg"
            logo-small-light="/hkcm/images/logo-small-on-light-background.svg"
            :cta-text="'Analyse-Pakete entdecken'"
            cta-link="/produkte"
            button-gradient-from="#006CFF"
            button-gradient-to="#006CFF"
            :show-ticker="true"
            ticker-text="+++ Ø<span class='font-semibold'> 70 % Trefferquote</span> über alle Analysebereiche +++ <span class='font-semibold'>Klare</span> Einstiegs-, Ausstiegs- und Risikomarken +++ <span class='font-semibold'>Strukturierte Szenarien</span> statt Bauchgefühl +++"
        />

        <!-- Hero Section -->
        <HeroSection
            background-color="radial-gradient(circle at 50% 50%, #072551 0%, #051A39 50%, #020E20 100%)"
            :badges="heroBadges"
            title="Struktur für Ihre Investment-Entscheidungen"
            title-highlight="Struktur"
            title-highlight-gradient-from="#006CFF"
            title-highlight-gradient-to="#006CFF"
            subtitle="Analysen für Aktien, Indizes, Rohstoffe und Krypto."
            :benefits="heroBenefits"
            cta-text="Jetzt Marktanalysen entdecken"
            :cta-link="{ name: 'products' }"
            :show-cta="true"
            button-gradient-from="#006CFF"
            button-gradient-to="#006CFF"
            :social-proof-text="socialProofText"
            social-proof-image="/hkcm/images/rezensionenBilder.png"
            :app-store-data="appStoreData"
            :google-play-data="googlePlayData"
            checkmark-color="text-blue"
            background-image="/hkcm/images/bg_candels.png"
        />

        <!-- Video Section -->
        <VideoSection
            background-color="transparent"
            video-url="https://iframe.mediadelivery.net/embed/369702/66e4cd87-682c-44ff-bba8-9cf41e58e7f5?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
            :video-height="500"
        />

        <!-- Content Section: Zwischen Hype -->
        <ContentSection
            background-color="bg-white"
            title="Zwischen Hype, Crash-Warnungen und<br> Bankprodukten: Wem können Sie noch vertrauen?"
            title-color="text-black"
            title-highlight="Zwischen Hype"
            title-highlight-gradient-from="#006CFF"
            title-highlight-gradient-to="#006CFF"
            :paragraphs="contentText1"
            text-color="text-black"
            :show-cta="true"
            cta-text="Jetzt Marktanalysen entdecken"
            :cta-link="{ name: 'products' }"
            button-gradient-from="#006CFF"
            button-gradient-to="#006CFF"
        />

        <!-- Numbered List Section: Für Anleger -->
        <NumberedListSection
            title="Für Anleger, die Verantwortung für ihr Vermögen<br class='hidden lg:block'> übernehmen wollen."
            title-highlight="Verantwortung"
            title-highlight-color="#006CFF"
            :items="targetAudienceItems"
            :image="targetAudienceImage"
            image-alt="HKCM Analyst"
        />

        <!-- Market Analysis Grid -->
        <MarketAnalysisGridSection :markets="markets" />

        <!-- WHAT YOU GET IN CRYPTO PACKAGES -->
        <FeatureCardsSection
            background-color="bg-gradient-to-b from-[#072551] to-[#020E20]"
            background-image="/hkcm/images/bg_candels2.png"
            title="So denken wir Märkte."
            title-highlight="Märkte."
            title-highlight-gradient-from="#006CFF"
            title-highlight-gradient-to="#006CFF"
            title-color="text-white"
            :cards="featureCards"
            card-background-color="bg-white"
            card-title-color="text-blue-dark"
            card-text-color="text-black"
            card-icon-color="text-blue"
            icon-size="text-[120px]"
            card-width="lg:w-[28rem] w-80"
            button-gradient-from="#8A38DC"
            button-gradient-to="#3B125E"
            :show-cta="false"
        />

        <!-- Content Section: Warum Anleger HKCM nutzen -->
        <ContentSection
            background-color="bg-white"
            title="Warum Anleger HKCM nutzen"
            title-color="text-blue-dark"
            title-highlight="HKCM"
            title-highlight-gradient-from="#006CFF"
            title-highlight-gradient-to="#006CFF"
            :paragraphs="contentText2"
            paragraphs-length="w-full"
            text-color="text-black"
            :show-cta="false"
        />

        <!-- Simple CTA Section -->
        <SimpleCTASection
            title="Verstehen Sie Märkte.<br> Treffen Sie bewusstere Entscheidungen."
            title-highlight="Märkte."
            title-highlight-color="#072551"
            title-color="text-white"
            subtitle="Unabhängige Marktanalysen für Aktien, Indizes, Rohstoffe und Krypto."
            cta-text="Jetzt Zugang sichern"
            :cta-link="{ name: 'products' }"
            button-gradient-from="#fff"
            button-gradient-to="#fff"
            :show-social-proof="true"
            :social-proof-text="socialProofText"
            social-proof-image="/hkcm/images/rezensionenBilder.png"
            :badges="heroBadges"
        />

        <!-- Who Is Behind Section -->
        <WhoIsBehindSection
            background-color="bg-[#006cff1a]"
            title="Wer hinter HKCM steht"
            title-highlight="HKCM"
            title-highlight-color="#006CFF"
            title-color="#1a1a1a"
            intro-text="Strukturierte Marktanalyse mit klarer Methodik — transparent, nachvollziehbar und regelmäßig aktualisiert."
            intro-text-color="#000"
            :paragraphs="whoIsBehindParagraphs"
            paragraph-color="#000"
            image="/hkcm/images/team/pk.jpg"
            image-alt="Philip Klinkmüller"
            badge-top-text="Über"
            badge-main-text="70 %"
            badge-bottom-text="Trefferquote"
            :features="whoIsBehindFeatures"
            feature-title-color="text-[#006CFF]"
            feature-subtitle-color="#000"
            checkmark-color="text-[#006CFF]"
        />

        <!-- 14) FINAL CTA -->
        <FinalCTASection
            background-color="linear-gradient(to bottom, #072551, #020E20)"
            title="Märkte verstehen, bevor<br class='lg:block hidden'> Sie handeln."
            title-highlight="Märkte"
            title-highlight-gradient-from="#006CFF"
            title-highlight-gradient-to="#006CFF"
            title-color="text-white"
            description="Analysen und Szenarien für Anleger, die Kontrolle behalten wollen."
            description-color="text-gray-200"
            image="/hkcm/images/zugang_zum_hype_aktien_paket.png"
            image-alt=""
            image-position="left"
            cta-text="Zugang zu unseren Marktanalysen"
            cta-link="/produkte"
            button-gradient-from="#006CFF"
            button-gradient-to="#006CFF"
            price-color="text-blue"
            fallback-cta-text="Hype-Aktien-Paket kaufen ab dem 23.02.2026"
            fallback-cta-background-color="#1E40AF"
        />

        <!-- Footer -->
        <LandingFooter
            background-color="#FFFFFF"
            logo="/hkcm/images/logo-on-light-background.svg"
            logo-link="/produkte"
            link-color="text-gray-600"
            cta-text="Analyse-Pakete entdecken"
            cta-link="/produkte"
            button-gradient-from="#006CFF"
            button-gradient-to="#006CFF"
        />
    </div>
</template>

<script setup>
import { ref } from 'vue';
import i18next from 'i18next';
import LandingNav from '../components/landing/LandingNav.vue';
import HeroSection from '../components/landing/HeroSection.vue';
import VideoSection from '../components/landing/VideoSection.vue';
import ContentSection from '../components/landing/ContentSection.vue';
import NumberedListSection from '../components/landing/NumberedListSection.vue';
import MarketAnalysisGridSection from '../components/landing/MarketAnalysisGridSection.vue';
import PhilosophySection from '../components/landing/PhilosophySection.vue';
import WhoIsBehindSection from '../components/landing/WhoIsBehindSection.vue';
import VideoContentSection from '../components/landing/VideoContentSection.vue';
import LandingFooter from '../components/landing/LandingFooter.vue';
import WhatYouGetSection from '../components/landing/WhatYouGetSection.vue';
import WhoIsItForSection from '../components/landing/WhoIsItForSection.vue';
import HowToUseSection from '../components/landing/HowToUseSection.vue';
import SimpleCTASection from '../components/landing/SimpleCTASection.vue';
import FeatureCardsSection from '../components/landing/FeatureCardsSection.vue';
import FinalCTASection from '../components/landing/FinalCTASection.vue';

// Feature Cards
const featureCards = [
    {
        title: "Szenarien statt<br class='hidden lg:block'> Prognosen",
        icon: '/hkcm/images/icons/map-trifold.svg',
        content: 'Wir definieren Wahrscheinlichkeiten - keine Versprechen.'
    },
    {
        title: "Struktur statt<br class='hidden lg:block'> Signal-Dienst",
        icon: '/hkcm/images/icons/squares-four.svg',
        content: 'Wir liefern Analyse, nicht „Kauf jetzt".'
    },
    {
        title: "Transparenz statt<br class='hidden lg:block'> Blackbox",
        icon: '/hkcm/images/icons/magnifying-glass.svg',
        content: 'Sie sehen, wie wir zu unseren Einschätzungen kommen.'
    },
    {
        title: "Unabhängigkeit statt<br class='hidden lg:block'> Produktinteresse",
        icon: '/hkcm/images/icons/scales.svg',
        content: 'Wir verwalten kein Geld und verkaufen keine Finanzprodukte.'
    }
];

// Hero Section Data
const heroBadges = [
    { src: '/hkcm/images/partners/BlackBull24_Krypto_square.png', alt: 'Black Bull Krypto Insider' },
    { src: '/hkcm/images/partners/BlackBull25_InvestmentVision.png', alt: 'Black Bull Investment Vision' },
    { src: '/hkcm/images/partners/DISQTrust_Siegel_Von Kunden_Empfohlen_HKCM.png', alt: 'DISQ Trust Siegel', class: 'w-full object-contain max-h-[180px] lg:w-auto' }
];

const heroBenefits = [
    "Unabhängige Analysen –<br class='hidden lg:block'> keine Produktverkäufe",
    "Klare Szenarien &<br class='hidden lg:block'> Risikokorridore",
    "Struktur für jede<br class='hidden lg:block'> Marktphase"
];

const socialProofText = 'Bereits über 25.000<br/>zufriedene Kunden';

const appStoreData = {
    badge: i18next.language === 'de' ? '/hkcm/images/apple-store-badge.png' : '/hkcm/images/apple-store-badge-en.png',
    link: 'https://apps.apple.com/de/app/hkcm/id6499010943',
    rating: '4.4',
    stars: '/hkcm/images/stars4_5_yellow.png',
    reviews: '1.8k'
};

const googlePlayData = {
    badge: i18next.language === 'de' ? '/hkcm/images/google-play-badge.png' : '/hkcm/images/google-play-badge-en.png',
    link: 'https://play.google.com/store/apps/details?id=de.hkcm.app&hl=de&pli=1',
    rating: '4.5',
    stars: '/hkcm/images/stars4_5_green.png',
    reviews: '7.3k'
};

// Stats Cards
const statsCards = [
    { title: '+15', description: 'Jahre Erfahrung am <br> Markt' },
    { title: '+15.000', description: 'Analysen<br>erstellt' },
    { title: '+1 mio.', description: 'Follower auf<br>YouTube' },
    { title: '+290', description: 'Durchschnittlich <br> Analysen im Monat' }
];

// Content Section Data
const contentText1 =
    'Die Märkte sind komplex.<br>' +
    'Aktien schwanken. Rohstoffe reagieren auf geopolitische Spannungen. Krypto bewegt sich in Zyklen. Indizes spiegeln globale Entwicklungen wider.<br>' +
    'Gleichzeitig liefern Social Media, Nachrichten und Bankgespräche oft widersprüchliche Signale.<br>\n' +
    '<ul style="list-style-type:disc; margin-left: 30px;; margin-bottom: 10px;">' +
    '<li>Zu viele Meinungen.</li>' +
    '<li>Zu wenig Struktur.</li>' +
    '<li>Zu wenig Zeit, alles selbst einzuordnen.</li>' +
    '</ul>' +
    'HKCM liefert keine Produktempfehlungen, sondern Marktstruktur.<br>' +
    'Wir analysieren Märkte, definieren Szenarien und zeigen, welche Entwicklungen aus unserer Sicht relevant sind – damit Sie bewusster entscheiden können.';

const contentText2 =
    'In einem Umfeld aus Meinungen, Schlagzeilen und Dauer-Alarmismus suchen viele Anleger nicht den nächsten Hype, sondern Klarheit.<br><br>HKCM steht für strukturierte Marktanalyse.<br>Wir reduzieren Komplexität, ohne Märkte zu vereinfachen.<br>Wir analysieren Szenarien, statt Prognosen zu versprechen.<br>Wir ordnen Entwicklungen ruhig ein, gerade dann, wenn Märkte emotional reagieren.<br><br>Was unsere Nutzer schätzen<br>Klare Marktstruktur statt Informationsüberflutung: Wir filtern Relevantes von Lärm und zeigen, welche Entwicklungen strategisch bedeutsam sind und welche nicht.<br><br>Analytische Einordnung auch in volatilen Phasen: Wenn Märkte schwanken, bleiben wir bei Daten, Struktur und Wahrscheinlichkeiten, nicht bei Emotionen.<br><br>Verbindung aus Research, Video-Analyse und Education: Sie erhalten nicht nur Einschätzungen, sondern auch das Verständnis dahinter – damit Sie Ihre eigenen Entscheidungen fundierter treffen können.';

// Markets Data
const markets = [
    {
        title: 'Aktienanalyse',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/product-categories/aktien-white.png',
        description: 'Einzelaktien, Sektortrends oder Hype. Wir analysieren Marktstruktur, Bewertung, technische & makroökonomische Einflussfaktoren.',
        bgClass: 'bg-gradient-to-b from-[#11D2D4] to-[#0C7475]',
        ctaText: 'Alle Analysen entdecken',
        link: { name: 'products' }
    },
    {
        title: 'Indizes',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/product-categories/indizes-white.png',
        description: 'DAX, Nasdaq und internationale Benchmarks. Indizes sind der Taktgeber der Märkte. Wir zeigen, wo wir im Zyklus stehen.',
        bgClass: 'bg-gradient-to-b from-[#F68242] to-[#9D4A1E]',
        ctaText: 'Alle Analysen entdecken',
        link: { name: 'products' }
    },
    {
        title: 'Krypto',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/product-categories/krypto-white.png',
        description: 'Bitcoin, Ethereum und ausgewählte Marktsegmente. Krypto folgt klaren Zyklen. Wir zeigen, wo Chancen liegen und wo Risiken dominieren.',
        bgClass: 'bg-gradient-to-b from-[#8A38DC] to-[#3B125E]',
        ctaText: 'Alle Analysen entdecken',
        link: { name: 'products' }
    },
    {
        title: 'Rohstoffe',
        image: 'https://hkcm-storage.s3.eu-central-1.amazonaws.com/product-categories/rohstoffe-white.png',
        description: 'Gold, Energie, Industriemetalle. Rohstoffe sind oft Inflations- oder Krisenindikatoren. wir analysieren Angebots-/Nachfragestrukturen und technische Setups.',
        bgClass: 'bg-gradient-to-b from-[#E2C750] to-[#93802F]',
        ctaText: 'Alle Analysen entdecken',
        link: { name: 'products' }
    }
];

// Target Audience Items
const targetAudienceItems = [
    {
        icon: 'fi fi-rr-navigation',
        title: '1. Für Anleger, die Verantwortung behalten wollen',
        description:
            'Sie investieren bereits, möchten aber nicht von Schlagzeilen oder Social Media getrieben werden.<br>Sie wollen wissen:<br>' +
            '&nbsp;&nbsp;&bull; Wie ordne ich Marktbewegungen sachlich ein?<br>' +
            '&nbsp;&nbsp;&bull; Welche Szenarien sind realistisch – welche übertrieben?<br>' +
            '&nbsp;&nbsp;&bull; Wie treffe ich Entscheidungen ohne Hektik?<br>' +
            'Wir liefern Struktur, damit Sie souverän entscheiden.'
    },
    {
        icon: 'fi fi-rr-chart-line-up',
        title: '2. Für Anleger, die mehr als nur ETF-Standard wollen',
        description:
            'Sie haben Kapital aufgebaut – und fragen sich:<br>' +
            'Reicht „Buy &amp; Hold" wirklich?<br>' +
            'Welche Marktphase haben wir gerade?<br>' +
            'Wo liegen reale Risiken?<br>' +
            'Wir liefern Einordnung, damit Sie Entscheidungen bewusst treffen.'
    },
    {
        icon: 'fi fi-rr-shield-check',
        title: '3. Für Anleger, die Unsicherheit reduzieren wollen',
        description:
            'Inflation, Zinsen, geopolitische Spannungen.<br>Sie wollen wissen:<br>' +
            '&nbsp;&nbsp;&bull; Was ist Marktgeräusch?<br>' +
            '&nbsp;&nbsp;&bull; Was ist strukturell relevant?<br>' +
            '&nbsp;&nbsp;&bull; Wie könnte sich das entwickeln?<br>' +
            'Wir arbeiten mit Szenarien statt Emotionen.'
    }
];

const targetAudienceImage = '/hkcm/images/lpOverviewExample.png';

// Philosophy Items
const philosophyItems = [
    {
        title: 'Szenarien statt<br/>Prognosen',
        icon: 'ph ph-map-trifold',
        description: 'Wir definieren Wahrscheinlichkeiten - keine Versprechen.'
    },
    {
        title: 'Struktur statt<br/>Signal-Dienst',
        icon: 'ph ph-squares-four',
        description: 'Wir liefern Analyse, nicht „Kauf jetzt".'
    },
    {
        title: 'Transparenz statt<br/>Blackbox',
        icon: 'ph ph-magnifying-glass',
        description: 'Sie sehen, wie wir zu unseren Einschätzungen kommen.'
    },
    {
        title: 'Unabhängigkeit statt Produktinteresse',
        icon: 'ph ph-scales',
        description: 'Wir verwalten kein Geld und verkaufen keine Finanzprodukte.'
    }
];

// Who Is It For Section Data
const whoIsItForCards = [
    {
        title: '… Sie Ihre Investmententscheidungen selbst treffen',
        description:
            'Sie möchten nicht blind Empfehlungen folgen, sondern nachvollziehen, warum bestimmte Marktbewegungen entstehen können. Unsere Analysen zeigen Struktur, Szenarien und Entscheidungsmarken, die Umsetzung liegt bei Ihnen.',
        icon: 'fi fi-rr-brain'
    },
    {
        title: '… Sie mit Kursmarken und Szenarien arbeiten möchten',
        description:
            'Unsere Methodik liefert keine pauschalen „Kaufen / Verkaufen"-Aussagen. Stattdessen erhalten Sie konkrete Marktmarken und alternative Szenarien. Das ist ideal für Anleger, die strukturiert planen und Entscheidungen an klaren Bedingungen ausrichten möchten.',
        icon: 'fi fi-rr-chart-line-up'
    },
    {
        title: '… Sie regelmäßig Kapital investieren',
        description:
            'Die Analysepakete entfalten ihren größten Nutzen für Anleger, die fortlaufend investieren oder bestehende Positionen aktiv managen. Wenn Sie monatlich oder regelmäßig Kapital am Markt einsetzen, helfen strukturierte Marktanalysen besonders bei Timing- und Risikofragen.',
        icon: 'fi fi-rr-coins'
    },
    {
        title: '… Sie Marktbewegungen besser verstehen wollen',
        description:
            'Viele Nutzer schätzen unsere Analysen nicht nur wegen der Marken, sondern wegen des Marktverständnisses. Sie lernen zu erkennen, in welcher Marktphase sich ein Wert befindet, ob eine Bewegung strukturell stabil wirkt, wo Korrekturen typisch sind, wann Strukturen brechen. Das stärkt Ihre eigene Entscheidungskompetenz.',
        icon: 'fi fi-rr-bulb'
    }
];

// How to Use Steps
const howToUseSteps = [
    {
        label: 'Analysepaket\nauswählen',
        active: true,
        icon: {
            paths: [
                {
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                    'stroke-width': '2',
                    d: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4'
                }
            ]
        }
    },
    {
        label: 'Zugriff\nerhalten',
        active: false,
        icon: {
            paths: [
                {
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                    'stroke-width': '2',
                    d: 'M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z'
                }
            ]
        }
    },
    {
        label: 'Kursmarken &\nSzenarien einsehen',
        active: false,
        icon: {
            paths: [
                {
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                    'stroke-width': '2',
                    d: 'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6'
                }
            ]
        }
    },
    {
        label: 'Eigene Entscheidungen\nableiten',
        active: false,
        icon: {
            paths: [
                {
                    'stroke-linecap': 'round',
                    'stroke-linejoin': 'round',
                    'stroke-width': '2',
                    d: 'M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z'
                }
            ]
        }
    }
];

// Who Is Behind Section Data
const whoIsBehindParagraphs = [
    'HKCM steht für strukturierte Marktanalyse statt Meinungsprognose. Unser Fokus liegt darauf, Marktbewegungen methodisch einzuordnen und daraus klare Szenarien sowie Kursmarken abzuleiten.',
    'Unsere Analysen basieren auf der Elliott-Wellen-Theorie – nicht, weil sie „kompliziert klingt", sondern weil sie Marktphasen und Korrekturen systematisch beschreibbar macht. Das Ziel ist nicht, den Markt perfekt vorherzusagen, sondern Ihnen ein nachvollziehbares Modell zu geben, mit dem Sie Entscheidungen strukturierter treffen können.',
    'Wir arbeiten mit einem szenariobasierten Ansatz. Das bedeutet: Sie erhalten nicht nur eine Richtung, sondern mehrere mögliche Entwicklungen — inklusive klarer Marken, ab wann ein Szenario bestätigt oder verworfen ist. So entsteht Orientierung, gerade in volatilen Marktphasen.'
];

const whoIsBehindFeatures = [
    { title: "Methodik statt<br class='hidden lg:block'> Meinung", subtitle: 'feste<br>Analyse-Logik' },
    { title: "Szenarien statt<br class='hidden lg:block'> Prognosen", subtitle: 'klar definierte<br>Bedingungen' },
    { title: "Kursmarken statt<br class='hidden lg:block'> Bauchgefühl", subtitle: 'transparente<br>Entscheidungszonen' },
    { title: "Regelmäßige<br class='hidden lg:block'> Updates", subtitle: 'Anpassungen bei<br>Marktveränderungen' }
];

// Final CTA Text
const finalCtaText = 'Analysen und Szenarien für Anleger, die Kontrolle behalten wollen.';
</script>

<style scoped>
.landing-page {
    overflow-x: hidden;
}
</style>
